import React, { useState } from "react";
import { useLocation,useNavigate } from "react-router";
import { Stepper,Step } from "@progress/kendo-react-layout";
import "../communication.css";
import { ADD_NOTIFICATION_INFORMATION } from "../../../routes";

const items = [
    {
      label: "Information",
      value: 0,
    },    
    {
      label: "Distribution",
      value: 1,
    },        
    {
      label: "Attachment",
      value: 2,
    },
    {
      label: "Review",
      value: 3
    }
  ];

  const SplahScreenitems = [
    {
      label: "Information",
      value: 0,
    },      
    {
      label: "Attachment",
      value: 1,
    },
    {
      label: "Review",
      value: 2
    }
  ];
const CustomStep = (props) => {
    return (
      <Step {...props}>
        <div className="custom-step">
          <span>{props.svgIcon}</span>
        </div>
        <span className="step-label">{props.label}</span>
      </Step>
    );
  };

export const AddNotificationSteps = (props) => {
  const navigate = useNavigate();
  let { search } = useLocation();
  const query = new URLSearchParams(search);  
  const handleChange = (e) => {
    // e.preventDefault();
    if(query.get("id") || query.get("copyId")){
      if(props.isSplashOnly && e.value != 0){
        props.setState(e.value+1);
        query.set("state",e.value+1);
      }
      else{
        props.setState(e.value);
        query.set("state",e.value);  
      }
      navigate(ADD_NOTIFICATION_INFORMATION+"?"+query.toString());     
    }
  };
  console.log(props.state);
  console.log(props.isSplashOnly);
  return (
    <>
        <div className="progress-steps-group">
            <div className="progress-steps-inside-group">
                <Stepper 
                  className="notification-steps" 
                  value={props.isSplashOnly && props.state != 0? props.state-1 : props.state} 
                  items={props.isSplashOnly? SplahScreenitems: items}
                  // item={CustomStep}
                  onChange={(e)=>handleChange(e)} 
                />
            </div>
        </div>
    </>
  );
};